import { Text } from '@smuchile/pkg-unimarc-components'
import { useMobile } from '@smuchile/pkg-unimarc-hooks'

export const SearchResult = () => {
  const { isMobile } = useMobile()
  const fontSize = isMobile ? 'md' : 'base'

  return (
    <Text
      color='grayNeutral'
      fontSize={fontSize}
    >
      1 resultado de búsqueda
    </Text>
  )
}
